import styles from './EsignSendButtons.module.scss'

interface SendOutcome {
    success: boolean
}

interface Props {
    isSending: null | 'email' | 'sms'
    emailResult: SendOutcome | null
    smsResult: SendOutcome | null
    onSendEmail: () => void
    onSendSms: () => void
    emailLabel?: string
    smsLabel?: string
}

export const EsignSendButtons = ({
    isSending,
    emailResult,
    smsResult,
    onSendEmail,
    onSendSms,
    emailLabel = 'Send Signature Link (Email)',
    smsLabel = 'Send Signature Link (SMS)',
}: Props) => (
    <div className={styles.wrapper}>
        <button
            type="button"
            className={`${styles.button}${emailResult?.success ? ` ${styles.buttonSent}` : ''}`}
            onClick={onSendEmail}
            disabled={isSending !== null}
        >
            <span className={styles.inner}>
                {isSending === 'email' && <span className={styles.spinner} />}
                {emailResult?.success && !isSending && <span>✓</span>}
                <span>
                    {isSending === 'email'
                        ? 'Sending…'
                        : emailResult?.success
                        ? 'Email sent successfully'
                        : emailLabel}
                </span>
            </span>
        </button>
        <button
            type="button"
            className={`${styles.button}${smsResult?.success ? ` ${styles.buttonSent}` : ''}`}
            onClick={onSendSms}
            disabled={isSending !== null}
        >
            <span className={styles.inner}>
                {isSending === 'sms' && <span className={styles.spinner} />}
                {smsResult?.success && !isSending && <span>✓</span>}
                <span>
                    {isSending === 'sms'
                        ? 'Sending…'
                        : smsResult?.success
                        ? 'SMS sent successfully'
                        : smsLabel}
                </span>
            </span>
        </button>
    </div>
)
